import { CommitAction } from '@/enum/CommitAction'
import { AlsBase, getDefaultAlsBase } from './AlsBase'


export interface AlsCours extends AlsBase {    
    from: Date,
    to:   Date,
    psnId: number|null  
}

export const getDefaultAlsCours = (commit:CommitAction=CommitAction.listAndDic):AlsCours => {     
    return {
        ...getDefaultAlsBase(commit),
        from: new Date(),
        to: new Date(),
        psnId:null
    }
}

export const cleanAlsCours = (filter:AlsCours) => {
    if(!filter) return        
    if(!filter.psnId) delete filter.psnId
}
